import { makeHttpRequest } from "@/shared";

export const deleteProducts = async (ids) => {
    const response = (
        await makeHttpRequest({
            url: "/product/delete-multiple",
            method: "DELETE",
            params: {
                items: ids,
            },
        })
    ).data;

    return response;
};
